var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38293 0 0 5.38293 0 12C0 18.6171 5.38293 24 12 24C18.6171 24 24 18.6171 24 12C24 5.38293 18.6171 0 12 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4192 15.0048C16.8101 15.3959 16.8101 16.0278 16.4192 16.4189C16.2242 16.6139 15.9682 16.7119 15.712 16.7119C15.456 16.7119 15.2001 16.6139 15.0051 16.4189L12.0001 13.4138L8.99516 16.4189C8.80016 16.6139 8.54417 16.7119 8.28819 16.7119C8.03203 16.7119 7.77605 16.6139 7.58104 16.4189C7.19011 16.0278 7.19011 15.3959 7.58104 15.0048L10.5862 11.9999L7.58104 8.99492C7.19011 8.60381 7.19011 7.97191 7.58104 7.5808C7.97215 7.18987 8.60405 7.18987 8.99516 7.5808L12.0001 10.5859L15.0051 7.5808C15.3962 7.18987 16.0281 7.18987 16.4192 7.5808C16.8101 7.97191 16.8101 8.60381 16.4192 8.99492L13.414 11.9999L16.4192 15.0048Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.1131c4747daab975cc03a64fb699f970.svg";
export { ForwardRef as ReactComponent };